import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { display } from 'styled-system';

import { useConfig } from 'Context/ConfigContext';
import { useCapacitor } from 'Util/Capacitors';

import { Flex, SvgIcon } from '../Base';

const Container = styled(Flex)`
  height: ${(props) => props.height};
  align-items: center;
  user-select: none;
  // [Safari] Removes grey highlight on tap
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
`;

const ResponsiveBox = styled(Flex)`
  position: relative;
  align-items: center;
  height: 100%;
  ${display}
`;

const QRScanner = ({ height }) => {
  const { openUrl, scanBarcode } = useCapacitor();
  const { MoEBookRedirectApi } = useConfig();

  const scan = async () => {
    const url = await scanBarcode();
    if (url) {
      openUrl(`${MoEBookRedirectApi}?url=${url}`);
    }
  };
  return (
    <Container height={height}>
      <ResponsiveBox onClick={scan}>
        <SvgIcon icon={SvgIcon.ICON_LIST.QRSCANNER} size={28} color={'white'} />
      </ResponsiveBox>
    </Container>
  );
};

QRScanner.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

QRScanner.defaultProps = {
  height: 28,
};

export default QRScanner;
